import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		fontFamily: theme.fonts.bold,
		fontSize: "36px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue2,
		margin: 0,
		padding: 0,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			fontSize: "24px",
		},
	},
});

class H1 extends React.Component {
	render() {
		let classes = this.props.classes;
		return <h1 className={classes.root}>{this.props.children}</h1>;
	}
}
export default withStyles(styles)(H1);
